function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';

var RatioPlaceHolder = function (_React$Component) {
  _inheritsLoose(RatioPlaceHolder, _React$Component);

  function RatioPlaceHolder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = RatioPlaceHolder.prototype;

  _proto.render = function render() {
    var props = this.props;
    var contentStyle = {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%'
    };
    return React.createElement("span", {
      className: "ratio-placeholder " + (props.className || ''),
      style: spacerStyle(props)
    }, React.createElement("span", {
      style: contentStyle
    }, props.children));
  };

  return RatioPlaceHolder;
}(React.Component);

_defineProperty(RatioPlaceHolder, "propTypes", {
  className: PropTypes.string,
  style: PropTypes.object,
  ratio: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
});

export default RatioPlaceHolder;

function spacerStyle(props) {
  var w, h;

  if (props.ratio) {
    var _props$ratio$split = props.ratio.split(':');

    w = _props$ratio$split[0];
    h = _props$ratio$split[1];
  } else if (props.width && props.height) {
    var _ref = [props.width, props.height];
    w = _ref[0];
    h = _ref[1];
  } else {
    throw new Error('RatioPlaceholder requires either a ratio property of "w:h" or width and height properties');
  }

  return Object.assign({
    display: 'inline-block',
    overflow: 'hidden',
    width: '100%',
    backgroundColor: props.color || 'none',
    position: 'relative',
    paddingBottom: h / w * 100 + "%",
    textAlign: 'center'
  }, props.style);
}